import { EActivityAuditStatus } from '@constants';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

import { StyledTag, TextWrapper, Wrapper } from './ActivityAuditStatusTag.styles';

import { ACTIVITY_AUDIT_STATUS_TAG_INFO } from '@/constants';

type Props = {
  auditStatus: EActivityAuditStatus;
  iconOnly?: boolean;
  onClick?: (auditStatus: EActivityAuditStatus) => void;
};

export const ActivityAuditStatusTag: React.FC<Props> = ({
  auditStatus,
  iconOnly = false,
  onClick
}) => {
  const { t } = useTranslation();

  const { color, icon } = ACTIVITY_AUDIT_STATUS_TAG_INFO[auditStatus];

  return (
    <StyledTag
      bgcolor={color}
      onClick={e => {
        e.stopPropagation();
        onClick?.(auditStatus);
      }}>
      <Wrapper color={color}>
        <Icon i={icon} />
        {iconOnly ? null : <TextWrapper>{t(auditStatus)}</TextWrapper>}
      </Wrapper>
    </StyledTag>
  );
};
